import { inject, Injectable } from '@angular/core';
import { Api } from '../api/api.service';
import { BaseService } from '../base.service';
import { Session } from '../session/session.service';

@Injectable({
  providedIn: 'root',
})
export class HelpLinkService extends BaseService {
  private api = inject(Api);
  private session = inject(Session);

  async getHelpUrl(): Promise<string> {
    const config = await this.api.configs.get();
    const base = this.session.user ? config.helpDocsUrl : config.helpLoginUrl;
    const suffix = this.getHelpUrlSuffix();
    const baseTrimmed =
      base.endsWith('/') || !suffix.length ? base : `${base}/`;
    return `${baseTrimmed}${suffix}`;
  }

  private getHelpUrlSuffix(): string {
    const key = this.getKeyFromPath();
    switch (key) {
      case 'view|search':
        return '4-View/Search_History_Watchlist/ClaimSearch.htm';
      case 'view|filter':
        return '4-View/Search_History_Watchlist/Filter search.htm';
      case 'view|history':
        return '4-View/Search_History_Watchlist/History.htm';
      case 'view|watchlist':
        return '4-View/Search_History_Watchlist/Watchlist.htm';
      case 'todo|Shared%20diaries':
        return '5-To-do/Shared diaries.htm';
      case 'todo|Personal%20tasks':
        return '5-To-do/Personal tasks.htm';
      case 'reports|reports|Reports':
        return '6-Reports/Personalized tab.htm';
      case 'reports|scheduled|Reports':
        return '6-Reports/Scheduled tab.htm';
      case 'reports|completed':
        return '6-Reports/Completed tab.htm';
      case 'reports|filters|Reports':
        return '6-Reports/Filters tab.htm';
      case 'reports|pending-reports':
        return '6-Reports/Shared reports tab.htm';
      case 'reports|pending-filters|Reports':
        return '6-Reports/Shared filters tab.htm';
      case 'query|':
        return '6-Reports/Reports.htm';
      case 'query|Query':
        return '6-Reports/Reports.htm';
      case 'alerts|messages|Alerts':
        return '7-Alerts/Alert Messages.htm';
      case 'alerts|my-alerts|Alerts':
        return '7-Alerts/Manage Alerts.htm';
      case 'view|':
        return '4-View/Claim/Claim.htm';
      case 'view|claim|disability||Disability':
        return '4-View/Claim/Details/Disability.htm';
      case 'view|claim|':
        return '4-View/Claim/Summary/Summary.htm';
      case 'view|claim|benefit-plan||Benefitplan':
        return '4-View/Claim/Details/Benefit plan.htm';
      case 'view|claim|medical||Medical':
        return '4-View/Claim/Details/Medical.htm';
      case 'view|claim|time-tracking||Timetracking':
        return '4-View/Claim/Details/Time tracking.htm';
      case 'view|claim|legal||Legal':
        return '4-View/Claim/Details/Legal.htm';
      case 'view|claim|appeals||Appeals':
        return '4-View/Claim/Details/Appeals.htm';
      case 'view|claim|custom-fields||Customfields':
        return '4-View/Claim/Details/Custom fields.htm';
      case 'view|claim|payment-history||Paymenthistory':
        return '4-View/Claim/Financials/Payment History.htm';
      case 'view|claim|recoveries||Recoveries':
        return '4-View/Claim/Financials/Recoveries.htm';
      case 'view|claim|overpayments||Overpayments':
        return '4-View/Claim/Financials/Overpayments.htm';
      case 'view|claim|offsets||Offsets':
        return '4-View/Claim/Financials/Offsets.htm';
      case 'view|claim|notes||Notes':
        return '4-View/Claim/Documentation/Notes.htm';
      case 'view|claim|examiner-diary||Examinerdiary':
        return '4-View/Claim/Documentation/Examiner diary.htm';
      case 'view|claim|documents||Documents':
        return '4-View/Claim/Documentation/Documents.htm';
      case 'view|claim|employee-detail||Employeedetail':
        return '4-View/Claim/HR Data/Employee detail.htm';
      case 'view|claim|job-history||Jobhistory':
        return '4-View/Claim/HR Data/Job history.htm';
      case 'view|claim|hr-contacts||HRcontacts':
        return '4-View/Claim/HR Data/HR Contacts.htm';
      case 'view|claim|deductions||Deductions':
        return '4-View/Claim/HR Data/Deductions.htm';
      case 'view|claim|deductions||Deductions/Liens':
        return '4-View/Claim/HR Data/Deductions.htm';
      case 'view|claim|dependents':
        return '4-View/Claim/HR Data/Dependents.htm';
      case 'view|claim|payroll||Payroll':
        return '4-View/Claim/HR Data/Payroll.htm';
      case 'view|claim|payroll||Taxes':
        return '4-View/Claim/HR Data/Payroll.htm';
      case 'view|claim|accruals||Accruals':
        return '4-View/Claim/HR Data/Accruals.htm';
      case 'view|claim|earnings||Earnings':
        return '4-View/Claim/HR Data/Earnings.htm';
      case 'view|claim|document-tasks|Shared%20diaries|Myto-do':
        return '4-View/Claim/To-do/Shared diaries (Claim To-do).htm';
      case 'view|claim|document-tasks|Personal%20tasks|Myto-do':
        return '4-View/Claim/To-do/Personal tasks (Claim To-do).htm';
      case 'view|claim|sidekick-summary||OmniAISummary':
        return '4-View/Claim/Details/Omni%20AI%20summary.htm';
      case "view|claim|workers-compensation||Workers'compensation":
        return '4-View/Claim/Details/Workers compensation.htm';
      case 'view|claim|claimant||Claimant':
        return '4-View/Claim/Details/Claimant.htm';
      case 'view|claim|medicare||Medicare':
        return '4-View/Claim/Details/Medicare.htm';
      case 'view|claim|case-management||Casemanagement':
        return '4-View/Claim/Details/Case management.htm';
      case 'view|claim|vendor-referral||Vendorreferrals':
        return '4-View/Claim/Details/Vendor referrals.htm';
      case 'view|claim|plan-summary||Plansummary':
        return '4-View/Claim/Details/Plan summary.htm';
      case 'view|claim|policy-details||Policydetails':
        return '4-View/Claim/Details/Policy details.htm';
      case 'view|claim|overview||Overview':
        return '4-View/Claim/Financials/Overview.htm';
      case 'view|claim|invoice-list||Bill/InvoiceList':
        return '4-View/Claim/Financials/Bill Invoice.htm';
      case 'view|claim|reserves||Reserves':
        return '4-View/Claim/Financials/Reserves.htm';
      case 'view|claim|reimbursements||Reimbursements':
        return '4-View/Claim/Financials/Reimbursements.htm';
      case 'view|claim|index-system||Indexsystem':
        return '4-View/Claim/Documentation/Index system.htm';
      case 'view|claim|edi||EDI(ElectronicDataInterchange)':
        return '4-View/Claim/Documentation/EDI.htm';
      case 'view|claim|service-instructions||Serviceinstructions':
        return '4-View/Claim/Documentation/Service instructions.htm';
      case 'dashboards|':
        return '8-Dashboards/Dashboards.htm';
      case 'view|claim|dependents||Dependents':
        return '4-View/Claim/HR Data/Dependents.htm';
      case 'reports|my-report|':
        return '6-Reports/Report detail.htm';
      case 'reports|scheduled-report|':
        return '6-Reports/Scheduled tab.htm';
      case 'reports|distributed-report|':
        return '6-Reports/Distributed reports/Distributed report detail.htm';
      case 'reports|completed-report|':
        return '6-Reports/Completed tab.htm';
      case 'reports|edit-filter||Newfilter':
        return '6-Reports/Report creation/Filter step.htm';
      case 'reports|edit-filter||Editfilter':
        return '6-Reports/Report creation/Filter step.htm';
      case 'reports|new-report|':
        return '6-Reports/Report creation/Creating a new report overview.htm';
      case 'reports|edit-report|':
        return '6-Reports/Report creation/Filter step.htm';
      case 'alerts|edit-alert||Editalert':
        return '7-Alerts/New Alert.htm';
      case 'alerts|edit-alert||Newalert':
        return '7-Alerts/New Alert.htm';
      case 'preferences||Preferences':
        return '2-Basics/Preferences.htm';
      case 'communication-preferences|':
        return '2-Basics/CommunicationPreferences.htm';
      case 'password-change||Preferences':
        return '2-Basics/ChangePassword.htm';
      case 'diary-edit||Newdiary':
        return '5-To-do/Shared diaries.htm';
      case 'task-edit||Newtask':
        return '5-To-do/Personal tasks.htm';
      case 'diary-types||Diarytypes':
        return '5-To-do/Diary types.htm';
      case 'reports|edit-report||Editreport':
        return '6-Reports/Report creation/Report step.htm';
      case 'reports|edit-report||Editdeliverydetails':
        return '6-Reports/Report detail.htm';
      case 'reports|pending-reports|Reports':
        return '6-Reports/Shared reports tab.htm';
      case 'reports|pending-report|':
        return '6-Reports/Report detail.htm';
      case 'view|claim|absence||Absence':
        return '4-View/Claim/Details/Absence.htm';
      case 'view|claim|leave-calendar||Leavecalendar':
        return '4-View/Claim/Details/Leave calendar.htm';
      case 'view|claim|certifications||Certifications':
        return '4-View/Claim/Details/Certifications.htm';
      case 'view|claim|eligibility||Eligibility':
        return '4-View/Claim/Details/Eligibility.htm';
      case 'view|claim|address-book||Contacts':
        return '4-View/Claim/Details/Contacts.htm';
      case 'view|claim|note-edit||Createnote':
        return '4-View/Claim/Documentation/Notes.htm';
      case 'view|claim|upload||Uploaddocuments':
        return '4-View/Claim/Documentation/Documents.htm';
      case 'view|claim|auto-liability||Autoliability':
        return '4-View/Claim/Details/Auto liability.htm';
      case 'view|claim|tender||Tender':
        return '4-View/Claim/Details/Tender.htm';
      case 'view|claim|general-liability||Generalliability':
        return '4-View/Claim/Details/General liability.htm';
      case 'view|claim|property||Property':
        return '4-View/Claim/Details/Property.htm';
      case 'view|claim|job-functions||Jobfunctions':
        return '4-View/Claim/Details/Job functions.htm';
      case 'view|claim|interactions||Interactionactivity':
        return '4-View/Claim/Details/Interactions.htm';
      case 'view|claim|restrictions||Essentialjobfunction':
        return '4-View/Claim/Details/Restrictions.htm';
      case 'view|claim|accommodations||Accommodations':
        return '4-View/Claim/Details/Accommodations.htm';
      case 'view|claim|milestones||Milestones':
        return '4-View/Claim/Details/Milestones.htm';
      case 'reports|new-report||Newreport':
        return '6-Reports/Reports.htm';
      case 'reports|completed|Reports':
        return '6-Reports/Completed tab.htm';
      case 'view|claim|disability||Accommodations':
        return '4-View/Claim/Details/Accommodations.htm';
      case 'query||Query':
        return '9-Query/QueryOverview.htm';
      case 'communication-preferences||Communicationpreferences':
        return '2-Basics/CommunicationPreferences.htm';

      default:
        return 'Welcome.htm';
    }
  }

  private getKeyFromPath(): string {
    let key = '';
    const paths = document.location.pathname.split('/');
    const searches = document.location.search.match(
      new RegExp('(?:tab=)([A-z-%0-9]+)'),
    );
    for (let p = 1; p < paths.length; p++) {
      // we want the first two and the last if its not a guid
      if (p < 3 || p === paths.length - 1) {
        if (paths[p].length < 39) {
          key += paths[p] + '|';
        }
      }
    }
    if (searches?.length > 1) {
      key += searches[1];
    }
    if (
      key !== 'reports|scheduled-report|' &&
      key !== 'reports|pending-report|' &&
      key !== 'reports|my-report|' &&
      key !== 'reports|completed-report|'
    ) {
      const h1 = document.querySelector('app-page-header h1');
      const h2 = document.querySelector('app-page-header h2');
      if (h1) {
        key += '|' + (h1 as HTMLElement).innerText.replace(/ /g, '');
      } else if (h2) {
        key += '|' + (h2 as HTMLElement).innerText.replace(/ /g, '');
      }
    }

    // console.log(`case '${key}':\r\n        return '';`);
    return key;
  }
}
